export function doPostMessage(msg) {
    msg.target = 'app';
    const json = JSON.stringify(msg);

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(json);
    } else if (window.parent && window.parent.postMessage) {
        window.parent.postMessage(json, '*');
    } else {
        window.postMessage(json, '*');
    }
};
